define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/html",
	"csi/widget/CheckBox",
	"csi/xml"
], function(declare,Ref,html,CheckBox,xml) {

	return declare(Ref, {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: only allow filtering for blanks / non-blanks
			// FIX: disable for now - neither approach below works

			// This option ends up filtering by name, so if referenced name is empty, then it will appear as blank just as an empty reference would
			// var qs = this.inherited(arguments);
			// qs.blanksOnly = true;
			// return qs;

			// This option is similar - empty references cannot be distinguished from empty names
			// return {
				// blanksOnly: true,
				// id: h.m_id,
				// index: h.m_index,
				// path: h.m_path,
				// ren: this,
				// type: this.type
			// };

			return null;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML
			var value = this._getValue(ctx, h);
			if (value == null) {
				return false;
			}

			var b = xml.isValidURL(value);

			if (ctx.bPrint) {
				// refer to csi/heading/Boolean
				var span = html.create("span", {"class": "csi-print-checkbox"}, refNode);

				if (b) {
					html.create("span", {
						"class": html.CSS_MATERIAL_ICON,
						innerText: "check"
					}, span);
				}
			} else {
				new CheckBox({
					disabled: true,
					value: b
				}).placeAt(refNode);
			}

			return true;
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			return "attrBoolean";
		}
	});
});